module.exports = __webpack_public_path__ + "img/guy.0443a5f7.svg";